import React, { useState } from 'react'

import AssignmentReturnedIcon from '@mui/icons-material/AssignmentReturned'
import VisibilityIcon from '@mui/icons-material/Visibility'
import { Dialog, DialogContent, DialogTitle, IconButton, Tooltip } from '@mui/material'
import copyToClipBoard from 'copy-to-clipboard'

import { Code } from 'components/_base'

type CampaignBannerCodeProps = {
  text: string
}

const CampaignBannerCode = ({ text }: CampaignBannerCodeProps) => {
  const [open, setOpen] = useState(false)

  return (
    <div className="campaign-banner-text">
      <Tooltip title="Show">
        <IconButton aria-label="Show" onClick={() => setOpen(true)} size="large">
          <VisibilityIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="Copy">
        <IconButton aria-label="Copy" onClick={() => copyToClipBoard(text)} size="large">
          <AssignmentReturnedIcon />
        </IconButton>
      </Tooltip>
      <Dialog onClose={() => setOpen(false)} open={open}>
        <DialogTitle>Code</DialogTitle>
        <DialogContent>
          <Code>{text}</Code>
        </DialogContent>
      </Dialog>
    </div>
  )
}

export default CampaignBannerCode
